import Image from "next/image";
import React from "react";
import styles from "./upsc-mains-test-series-2023.module.css";
import Link from "next/link";


import Rajeshwari from "../../assets/images/upsc/Toppers/2025/AIR-02-Rajeshwari-suve-m.png"; 
import MOHAIDEEN1 from "../../assets/images/upsc/Toppers/2025/AIR-07-RAJAH-MOHAIDEEN1.png";
import Kiran from "../../assets/images/upsc/Toppers/2025/AIR-53-Kiran-Kamate.png";
import RESHMA from "../../assets/images/upsc/Toppers/2025/AIR-181-S-RESHMA.png";
import KIRUTHIKA from "../../assets/images/upsc/Toppers/2025/AIR-184-KIRUTHIKA-M.png";
import SESHAN from "../../assets/images/upsc/Toppers/2025/AIR-197-SESHAN-MS.png";

 import MAHANDHI from "../../assets/images/upsc/Toppers/2025/AIR-227-MAHANDHI-R.png";
import VAIKAVI from "../../assets/images/upsc/Toppers/2025/AIR-306-VAIKAVI-VS.png";
import JASEELA from "../../assets/images/upsc/Toppers/2025/AIR-397-JASEELA-JANNATH-P.png";

import Vinith from "../../assets/images/upsc/Toppers/2025/AIR-484-Vinith-V.png";
import NIVETHA from "../../assets/images/upsc/Toppers/2025/AIR-498-RESHMA-NIVETHA-R.png";
import VISHALI from "../../assets/images/upsc/Toppers/2025/AIR-530-VISHALI-P.png";
import Abinesh from "../../assets/images/upsc/Toppers/2025/AIR-658-Abinesh.png";
import MUTHU from "../../assets/images/upsc/Toppers/2025/AIR-692-MK-MUTHU-KUMAR.png";
import DHANESHWAR from "../../assets/images/upsc/Toppers/2025/AIR-698-DHANESHWAR-M.png"; 

// import SANJAY from "../../assets/images/upsc/Toppers/AIR-268-SANJAY-SRINIVASAN.jpg";
// import SAIKIRAN from "../../assets/images/upsc/Toppers/AIR-298-SAI-KIRAN.jpg";


const UPSC_Main_Test_Series_2023 = () => {

    return (
        <>

      {/*  <div className="container pt-3 pt-md-4">
            <div className="row">
            
            <div className="col-lg-8 col-12">
            <Link href="/upsc-mains-test-series/#gsttestseries"><button className={`${styles.normalbutton2} mt-2 mt-md-0`} type="submit">Mains Test Series centre @ Hyderabad</button></Link>
            </div>
            <div className="col-lg-4 text-lg-end col-12 pt-lg-0 pt-md-3">
            <Link href="https://www.youtube.com/watch?v=zb1NHnxZ-VI" target="_blank"><button className={`${styles.normalbutton2} mt-2 mt-md-0`} type="submit">Why aspirants Choose us </button></Link>
            </div>
                <div className="col pt-3">
                <h2 className={`${styles.sectiontitle1} mb-0 py-3`}>Why Moksha?</h2>
                    <div class="accordion" id="accordionExample">

                        <div class="accordion-item">
                            <h2 class="accordion-header" id="headingOne">
                            <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                            <p className={`${styles.acheiverrank2} mb-0`}>Step-by-step Preparation</p>
                            </button>
                            </h2>
                            <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                                <p className={`${styles.acheiverrank}`}>Linear scheduling of tests ensure that you can plan and build your mains preparation effectively.</p>
                            </div>
                            </div>
                        </div>

                        <br/>

                        <div class="accordion-item">
                            <h2 class="accordion-header" id="headingTwo">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                            <p className={`${styles.acheiverrank2} mb-0`}>Structure / Design</p>
                            </button>
                            </h2>
                            <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                            <p className={`${styles.acheiverrank}`}>PRE and POST Test value additions ensure that you can improve your performance gradually.</p>
                            <div className="row">
                                <div className="col-xl-2 col-lg-3 col-md-4 col-12 py-xl-2 pt-3">
                                    <div className="p-4 h-100" style={{background: '#F4F6F8 0% 0% no-repeat padding-box', border: '1px solid #D9DFE6',opacity: '1'}}>
                                        <p className={`${styles.acheiverrank3} text-center mb-0`}>Orientation</p>
                                        <p className={`${styles.acheiverrank} text-center mb-0`}>WHAT to study? HOW to study? From WHERE to study?</p>
                                    </div>
                                </div>
                                <div className="col-xl-2 col-lg-3 col-md-4 col-12 py-xl-2 pt-3">
                                    <div className="p-4 h-100" style={{background: '#F4F6F8 0% 0% no-repeat padding-box', border: '1px solid #D9DFE6',opacity: '1'}}>
                                        <p className={`${styles.acheiverrank3} text-center mb-0`}>Test</p>
                                        <p className={`${styles.acheiverrank} text-center mb-0`}>Apply & test your preparation level</p>
                                    </div>
                                </div>
                                <div className="col-xl-2 col-lg-3 col-md-4 col-12 py-xl-2 pt-3">
                                    <div className="p-4 h-100" style={{background: '#F4F6F8 0% 0% no-repeat padding-box', border: '1px solid #D9DFE6',opacity: '1'}}>
                                        <p className={`${styles.acheiverrank3} text-center mb-0`}>Discussions</p>
                                        <p className={`${styles.acheiverrank} text-center mb-0`}>Understand the question paper & its expectations</p>
                                    </div>
                                </div>
                                <div className="col-xl-3 col-lg-3 col-md-4 col-12 py-xl-2 pt-3">
                                    <div className="p-4 h-100" style={{background: '#F4F6F8 0% 0% no-repeat padding-box', border: '1px solid #D9DFE6',opacity: '1'}}>
                                        <p className={`${styles.acheiverrank3} text-center mb-0`}>Analysis</p>
                                        <p className={`${styles.acheiverrank} text-center mb-0`}>WHAT you got right?<br/>WHAT went wrong?<br/>WHERE to improve?<br/>HOW much to improve?</p>
                                    </div>
                                </div>
                                <div className="col-xl-3 col-lg-3 col-md-4 col-12 py-xl-2 pt-3">
                                    <div className="p-4 h-100" style={{background: '#F4F6F8 0% 0% no-repeat padding-box', border: '1px solid #D9DFE6',opacity: '1'}}>
                                        <p className={`${styles.acheiverrank3} text-center mb-0`}>Feedback | Mentorship</p>
                                        <p className={`${styles.acheiverrank} text-center mb-0`}>(In-person | Online)<br/>HOW to improve?<br/>Evaluation 7 to 10 days</p>
                                    </div>
                                </div>
                            </div>
                            </div>
                            </div>
                        </div>

                        <br/>

                        <div class="accordion-item">
                            <h2 class="accordion-header" id="headingThree">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                            <p className={`${styles.acheiverrank2} mb-0`}>Simulation</p>
                            </button>
                            </h2>
                            <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                            <p className={`${styles.acheiverrank}`}>Closest possible simulation of UPSC Mains question evaluation standards to help you get exam-like experience.</p>
                            </div>
                            </div>
                        </div>

                        <br/>

                        <div class="accordion-item">
                            <h2 class="accordion-header" id="headingFour">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                            <p className={`${styles.acheiverrank2} mb-0`}>Pedagogy</p>
                            </button>
                            </h2>
                            <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                            <p className={`${styles.acheiverrank}`}>One of the best Mains Test Series team in India to guide you !</p>
                            <div className="row">
                               <div className="col-xl-2 col-lg-3 col-md-4 col-12 py-xl-2 pt-3">
                                    <div className="p-4 h-100" style={{background: '#BAE5F8 0% 0% no-repeat padding-box', opacity: '1'}}>
                                        <p className={`${styles.acheiverrank2} text-center mb-0`}>Senior Faculty</p>
                                        <Link href="/faculty-list" className={`${styles.paybill} d-flex justify-content-center`}>Click Here</Link>
                                    </div>
                                </div>
                                <div className="col-xl-2 col-lg-3 col-md-4 col-12 py-xl-2 pt-3">
                                    <div className="p-4 h-100" style={{background: '#B4DED3 0% 0% no-repeat padding-box', opacity: '1'}}>
                                        <p className={`${styles.acheiverrank2} text-center mb-0`}>CSE Toppers</p>
                                        <Link href="/successful-candidates" className={`${styles.paybill} d-flex justify-content-center`}>Click Here</Link>
                                    </div>
                                </div>
                                <div className="col-xl-3 col-lg-3 col-md-4 col-12 py-xl-2 pt-3">
                                    <div className="p-4 h-100" style={{background: '#D6E8BC 0% 0% no-repeat padding-box', opacity: '1'}}>
                                        <p className={`${styles.acheiverrank2} text-center`}>Experienced Mentors</p>
                                    </div>
                                </div>
                                <div className="col-xl-3 col-lg-3 col-md-4 col-12 py-xl-2 pt-3">
                                    <div className="p-4 h-100" style={{background: '#FEEABD 0% 0% no-repeat padding-box', opacity: '1'}}>
                                        <p className={`${styles.acheiverrank2} text-center`}>Subject Matter Experts</p>
                                    </div>
                                </div>
                            </div>
                            </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
    </div> */}
       
        <div className="container pt-2 pt-lg-3 mb-4 mb-md-5">
            <div className="row" >
                    <h2 className={`${styles.sectiontitle1} mb-0 py-3`}>Our Mains Toppers 2025</h2>

                    <div className="col-12  col-md-3 text-center py-xl-2 pt-3 pt-md-3">
                        <div className="h-100 pt-3 pb-3 " style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1' }}>
                            <div className={`${ styles.toppersupsc}`}> 
                              <Image src={Rajeshwari} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                            </div>
                            <span1 className={`${ styles.medalicon}`}></span1>
                                <p className={`${styles.acheivername} text-center mb-0`}> RAJESHWARI SUVE M</p>
                                <p className={`${styles.acheiverrank} text-center mb-0`}>AIR - 2 (2025)</p>
                                <p className={`${styles.acheivername} text-center mb-0 `}>Moksha Essay</p>  
                        </div>
                    </div>

                    <div className="col-12  col-md-3 text-center py-xl-2 pt-3 pt-md-3">
                        <div className="h-100 pt-3 pb-3 " style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1' }}>
                            <div className={`${ styles.toppersupsc}`}> 
                              <Image src={MOHAIDEEN1} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                            </div>
                            <span1 className={`${ styles.medalicon}`}></span1>
                                <p className={`${styles.acheivername} text-center mb-0`}>AR RAJAH MOHAIDEEN</p>
                                <p className={`${styles.acheiverrank} text-center mb-0`}>AIR - 7 (2025)</p>
                                <p className={`${styles.acheivername} text-center mb-0 `}>GSPCM</p>  
                        </div>
                    </div>

                    <div className="col-12  col-md-3 text-center py-xl-2 pt-3 pt-md-3">
                        <div className="h-100 pt-3 pb-3 " style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1' }}>
                            <div className={`${ styles.toppersupsc}`}> 
                              <Image src={Kiran} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                            </div>
                            <span1 className={`${ styles.medalicon}`}></span1>
                                <p className={`${styles.acheivername} text-center mb-0`}>KIRAN KAMATE</p>
                                <p className={`${styles.acheiverrank} text-center mb-0`}>AIR - 53 (2025)</p>
                                <p className={`${styles.acheivername} text-center mb-0 `}>GSPCM , Moksha </p>  
                        </div>
                    </div>

                    <div className="col-12  col-md-3 text-center py-xl-2 pt-3 pt-md-3">
                        <div className="h-100 pt-3 pb-3 " style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1' }}>
                            <div className={`${ styles.toppersupsc}`}> 
                              <Image src={RESHMA} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                            </div>
                            <span1 className={`${ styles.medalicon}`}></span1>
                                <p className={`${styles.acheivername} text-center mb-0`}>S RESHMA</p>
                                <p className={`${styles.acheiverrank} text-center mb-0`}>AIR - 181 (2025)</p>
                                <p className={`${styles.acheivername} text-center mb-0 `}>GSPCM , Moksha Freshers </p>  
                        </div>
                    </div>

                    <div className="col-12  col-md-3 text-center py-xl-2 pt-3 pt-md-3">
                        <div className="h-100 pt-3 pb-3 " style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1' }}>
                            <div className={`${ styles.toppersupsc}`}> 
                              <Image src={KIRUTHIKA} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                            </div>
                            <span1 className={`${ styles.medalicon}`}></span1>
                                <p className={`${styles.acheivername} text-center mb-0`}> KIRUTHIKA M</p>
                                <p className={`${styles.acheiverrank} text-center mb-0`}>AIR - 184 (2025)</p>
                                <p className={`${styles.acheivername} text-center mb-0 `}> Moksha Veterans</p>  
                        </div>
                    </div>

                    <div className="col-12  col-md-3 text-center py-xl-2 pt-3 pt-md-3">
                        <div className="h-100 pt-3 pb-3 " style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1' }}>
                            <div className={`${ styles.toppersupsc}`}> 
                              <Image src={SESHAN} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                            </div>
                            <span1 className={`${ styles.medalicon}`}></span1>
                                <p className={`${styles.acheivername} text-center mb-0`}> SESHAN M S</p>
                                <p className={`${styles.acheiverrank} text-center mb-0`}>AIR - 197 (2025)</p>
                                <p className={`${styles.acheivername} text-center mb-0 `}>GSPCM , Moksha AIMT</p>  
                        </div>
                    </div>

                    <div className="col-12  col-md-3 text-center py-xl-2 pt-3 pt-md-3">
                        <div className="h-100 pt-3 pb-3 " style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1' }}>
                            <div className={`${ styles.toppersupsc}`}> 
                              <Image src={MAHANDHI} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                            </div>
                            <span1 className={`${ styles.medalicon}`}></span1>
                                <p className={`${styles.acheivername} text-center mb-0`}>MAHANDHI R</p>
                                <p className={`${styles.acheiverrank} text-center mb-0`}>AIR - 227 (2025)</p>
                                <p className={`${styles.acheivername} text-center mb-0 `}> GSPCM , Moksha Freshers </p>  
                        </div>
                    </div>

                    <div className="col-12  col-md-3 text-center py-xl-2 pt-3 pt-md-3">
                        <div className="h-100 pt-3 pb-3 " style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1' }}>
                            <div className={`${ styles.toppersupsc}`}> 
                              <Image src={VAIKAVI} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                            </div>
                            <span1 className={`${ styles.medalicon}`}></span1>
                                <p className={`${styles.acheivername} text-center mb-0`}> VAIKAVI V S</p>
                                <p className={`${styles.acheiverrank} text-center mb-0`}>AIR - 306 (2025)</p>
                                <p className={`${styles.acheivername} text-center mb-0 `}>GSPCM , Moksha Mains Only</p>  
                        </div>
                    </div>

                    <div className="col-12  col-md-3 text-center py-xl-2 pt-3 pt-md-3">
                        <div className="h-100 pt-3 pb-3 " style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1' }}>
                            <div className={`${ styles.toppersupsc}`}> 
                              <Image src={JASEELA} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                            </div>
                            <span1 className={`${ styles.medalicon}`}></span1>
                                <p className={`${styles.acheivername} text-center mb-0`}>JASEELA JANNATH P</p>
                                <p className={`${styles.acheiverrank} text-center mb-0`}>AIR - 397 (2025)</p>
                                <p className={`${styles.acheivername} text-center mb-0 `}> Moksha Freshers</p>  
                        </div>
                    </div>

                    <div className="col-12  col-md-3 text-center py-xl-2 pt-3 pt-md-3">
                        <div className="h-100 pt-3 pb-3 " style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1' }}>
                            <div className={`${ styles.toppersupsc}`}> 
                              <Image src={Vinith} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                            </div>
                            <span1 className={`${ styles.medalicon}`}></span1>
                                <p className={`${styles.acheivername} text-center mb-0`}> VINITH V</p>
                                <p className={`${styles.acheiverrank} text-center mb-0`}>AIR - 484 (2025)</p>
                                <p className={`${styles.acheivername} text-center mb-0 `}> GSPCM</p>  
                        </div>
                    </div>

                    <div className="col-12  col-md-3 text-center py-xl-2 pt-3 pt-md-3">
                        <div className="h-100 pt-3 pb-3 " style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1' }}>
                            <div className={`${ styles.toppersupsc}`}> 
                              <Image src={NIVETHA} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                            </div>
                            <span1 className={`${ styles.medalicon}`}></span1>
                                <p className={`${styles.acheivername} text-center mb-0`}> RESHMA NIVETHA R</p>
                                <p className={`${styles.acheiverrank} text-center mb-0`}>AIR - 498 (2025)</p>
                                <p className={`${styles.acheivername} text-center mb-0 `}> GSPCM</p>  
                        </div>
                    </div>

                    <div className="col-12  col-md-3 text-center py-xl-2 pt-3 pt-md-3">
                        <div className="h-100 pt-3 pb-3 " style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1' }}>
                            <div className={`${ styles.toppersupsc}`}> 
                              <Image src={VISHALI} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                            </div>
                            <span1 className={`${ styles.medalicon}`}></span1>
                                <p className={`${styles.acheivername} text-center mb-0`}> VISHALI P</p>
                                <p className={`${styles.acheiverrank} text-center mb-0`}>AIR - 530 (2025)</p>
                                <p className={`${styles.acheivername} text-center mb-0 `}> Moksha Freshers</p>  
                        </div>
                    </div>


                     <div className="col-12  col-md-3 text-center py-xl-2 pt-3 pt-md-3">
                        <div className="h-100 pt-3 pb-3 " style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1' }}>
                            <div className={`${ styles.toppersupsc}`}> 
                              <Image src={Abinesh} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                            </div>
                            <span1 className={`${ styles.medalicon}`}></span1>
                                <p className={`${styles.acheivername} text-center mb-0`}> Acm Abinesh Kumar</p>
                                <p className={`${styles.acheiverrank} text-center mb-0`}>AIR - 658 (2025)</p>
                                <p className={`${styles.acheivername} text-center mb-0 `}>GSPCM</p>  
                        </div>
                    </div>

                    <div className="col-12  col-md-3 text-center py-xl-2 pt-3 pt-md-3">
                        <div className="h-100 pt-3 pb-3 " style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1' }}>
                            <div className={`${ styles.toppersupsc}`}> 
                              <Image src={MUTHU} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                            </div>
                            <span1 className={`${ styles.medalicon}`}></span1>
                                <p className={`${styles.acheivername} text-center mb-0`}> M K MUTHU KUMAR</p>
                                <p className={`${styles.acheiverrank} text-center mb-0`}>AIR - 692 (2025)</p>
                                <p className={`${styles.acheivername} text-center mb-0 `}>GSPCM , Moksha Freshers</p>  
                        </div>
                    </div>
                    

                     <div className="col-12  col-md-3 text-center py-xl-2 pt-3 pt-md-3">
                        <div className="h-100 pt-3 pb-3 " style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1' }}>
                            <div className={`${ styles.toppersupsc}`}> 
                              <Image src={DHANESHWAR} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                            </div>
                            <span1 className={`${ styles.medalicon}`}></span1>
                                <p className={`${styles.acheivername} text-center mb-0`}> DHANESHWAR M</p>
                                <p className={`${styles.acheiverrank} text-center mb-0`}>AIR - 698 (2025)</p>
                                <p className={`${styles.acheivername} text-center mb-0 `}>GSPCM</p>  
                        </div>
                    </div>

                     <div className=""style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <a href="https://www.shankariasacademy.com/our-achievers/" target="_blank" className={`${styles.more}  `}>& more ...</a>
                    </div>

                    {/* <div className="col-12  col-md-3 text-center py-xl-2 pt-3 pt-md-3">
                        <div className="h-100 pt-3 pb-3 " style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1' }}>
                            <div className={`${ styles.toppersupsc}`}> 
                              <Image src={SANJAY} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                            </div>
                            <span1 className={`${ styles.medalicon}`}></span1>
                                <p className={`${styles.acheivername} text-center mb-0`}> SANJAY SRINIVASAN R</p>
                                <p className={`${styles.acheiverrank} text-center mb-0`}>AIR - 268 (2024)</p>
                                <p className={`${styles.acheivername} text-center mb-0 `}> SIA Mains- Naan Mudhalvan </p>  
                        </div>
                    </div> */}

                    {/* <div className="col-12  col-md-3 text-center py-xl-2 pt-3 pt-md-3">
                        <div className="h-100 pt-3 pb-3 " style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1' }}>
                            <div className={`${ styles.toppersupsc}`}> 
                              <Image src={SAIKIRAN} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                            </div>
                            <span1 className={`${ styles.medalicon}`}></span1>
                                <p className={`${styles.acheivername} text-center mb-0`}> S SAIKIRAN</p>
                                <p className={`${styles.acheiverrank} text-center mb-0`}>AIR - 298 (2024)</p>
                                <p className={`${styles.acheivername} text-center mb-0 `}> Moksha Freshers GSPCM</p>  
                        </div>
                    </div> */}

            </div>    
        </div>
    
        </>
    )
}
export default UPSC_Main_Test_Series_2023;
